import { RouterLink } from '../../../components/AcademyLinks.migrated';
import UsageTracker from '../../../utils/UsageTracker';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useState } from 'react';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import { useMyLearningCardModels } from '../../myLearning/myLearningQueries';
import { MyLearningTabTypeToRequestMapping } from '../../myLearning/myLearningConsts';
import { useUserProgressState } from '../userProgressStore.migrated';
import CardsSection from 'academy-common-lib/features/cardsSection/components/CardsSection';
import { getMyLearningUrl } from '../../myLearning/myLearningRouting';
import HomePageSection from '../../../components/Layouts/HomePageSection';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const useInProgressSectionSimplified = numCards => {
  const {
    myLearningCardModels: inProgressItems,
    myLearningCardModelsLoading: inProgressItemsLoading,
    myLearningCardModelsError: inProgressItemsError,
    totalCount
  } = useMyLearningCardModels({
    contentTypes: MyLearningTabTypeToRequestMapping['all'],
    offset: {
      cursor: 0
    },
    pageLength: numCards,
    progressType: 'IN_PROGRESS',
    includePlaylistProgress: true
  });
  const {
    simulateNoProgress
  } = useUserProgressState();
  return {
    inProgressItems: simulateNoProgress ? [] : inProgressItems,
    inProgressItemsLoading,
    inProgressItemsError,
    totalCount
  };
};
const ViewAllLink = () => {
  const trackViewAllClick = () => UsageTracker.trackStandalone('Learning Center Interaction', {
    action: 'in-progress-view-all-clicked'
  });
  return /*#__PURE__*/_jsx(RouterLink, {
    marginInlineStart: "200",
    onClick: trackViewAllClick,
    to: `${getMyLearningUrl()}?progressStatus=IN_PROGRESS`,
    underline: true,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.inProgressSection.seeAll"
    })
  });
};
export const InProgressSectionSimplified = ({
  onRenderEmpty
}) => {
  const {
    isTablet
  } = useMediaQuery();
  const [maxCards, setMaxCards] = useState(isTablet ? 3 : 4);
  const {
    inProgressItems,
    inProgressItemsError,
    inProgressItemsLoading,
    totalCount
  } = useInProgressSectionSimplified(maxCards);
  const showViewMoreLink = totalCount > maxCards;
  return /*#__PURE__*/_jsx(HomePageSection, {
    paddingBlock: "0",
    children: /*#__PURE__*/_jsx(CardsSection, {
      appearsIn: "in-progress-section",
      cardsContainerProps: {
        paddingBlockEnd: '0'
      },
      content: inProgressItems,
      description: /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.inProgressSection.sectionSubtitle"
        }), isTablet && showViewMoreLink && /*#__PURE__*/_jsx(ViewAllLink, {})]
      }),
      direction: isTablet ? 'column' : 'row',
      error: inProgressItemsError,
      errorMarker: "HOMEPAGE_IN_PROGRESS_ERROR",
      flush: true,
      header: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.inProgressSection.sectionTitle"
      }),
      headerActions: !isTablet && showViewMoreLink && /*#__PURE__*/_jsx(ViewAllLink, {}),
      isLoading: inProgressItemsLoading,
      maxSkeletonListLength: maxCards,
      navMarker: !inProgressItemsLoading && !inProgressItemsError ? 'HOMEPAGE_IN_PROGRESS_LOADED' : undefined,
      onRenderEmpty: onRenderEmpty,
      overviewType: "in-progress-section",
      setMaxCards: setMaxCards,
      size: isTablet ? 'small' : 'large'
    })
  });
};